import { getWindowObject } from '@eventbrite/feature-detection';
import { splitReducer } from '@splitsoftware/splitio-redux';
import { SPLIT_IO_API_KEYS } from '../constants';

const getSplitioKey = (prodKey: string | null) => {
    if (prodKey) {
        return prodKey;
    }
    const { hostname } = getWindowObject('location') || {};
    return hostname?.includes('dev')
        ? SPLIT_IO_API_KEYS.dev
        : SPLIT_IO_API_KEYS.evbqa;
};

export const getSplitioClient = (eventId: string, prodKey: string | null) => ({
    core: {
        authorizationKey: getSplitioKey(prodKey),
        key: eventId, // Unique id to track anonymous users
    },
    startup: {
        readyTimeout: 1.5,
    },
});

export const createMockSplitState: (
    flags: any,
) => ReturnType<typeof splitReducer> = (flags: any) => {
    const treatments: any = Object.fromEntries(
        Object.keys(flags).map((key) => [
            key,
            { 1: { treatment: flags[key] } },
        ]),
    );
    return {
        isReady: true,
        isReadyFromCache: true,
        isTimedout: true,
        hasTimedout: true,
        isDestroyed: true,
        lastUpdate: -1,
        treatments,
    };
};

interface FindArrayAttributesTreatmentParams {
    featureFlag: string;
    attributes: readonly (string | number)[];
    attributeName: string;
    getTreatments: any;
    extraAttributes?: Record<string, string | boolean>;
}

export const findArrayAttributesTreatment = async ({
    featureFlag,
    attributes,
    attributeName,
    getTreatments,
    extraAttributes,
}: FindArrayAttributesTreatmentParams): Promise<Record<string, boolean>> => {
    const attributesTreatment: Record<string, boolean> = {};

    for (const value of attributes) {
        const treatments = await getTreatments({
            splitNames: [featureFlag],
            attributes: {
                [attributeName]: [value],
                ...extraAttributes,
            },
        });

        const treatment =
            treatments?.payload?.treatments?.[featureFlag]?.treatment;
        attributesTreatment[value] =
            treatment === 'on' || treatment === 'control' ? true : false;
    }

    return attributesTreatment;
};
